import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-student-pbis",
	templateUrl: "./student-pbis.component.html",
	styleUrls: ["./student-pbis.component.css"],
})
export class StudentPBISComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	SelectModeID: any = 0;

	lstSelectMode: any = [
		{
			ID: 0,
			Desc: "Person",
		},
		{
			ID: 1,
			Desc: "Group",
		},
	];

	/////////////////////////////////////////
}
